/** Release destinations selected with the registered VITE_APP_ENV input. */
export function landingDestinations(environment: string | undefined) {
  const staging = environment === 'staging'
  const origin = staging ? 'https://staging.genie.art' : 'https://genie.art'
  const app = staging ? 'https://app.staging.genie.art' : 'https://app.genie.art'
  return { app, login: `${app}/login`, download: `${origin}/download`, latestBuild: `${origin}/download/latest.json`, api: staging ? origin : 'https://api.genie.art' }
}
